<script>
    export let value;
    export let callback;
    export let props;
</script>

<input
    type="checkbox"
    bind:checked={value}
    on:change={() => {
        callback(value, props);
    }}
/>
